// extracted by mini-css-extract-plugin
export default {"container":"AllDevices__container-jDgSg","checkboxes":"AllDevices__checkboxes-JHUhI","checkbox":"AllDevices__checkbox-qYVew"};